import { SearchProps } from '~components/form-fields/search';

import { NeedPriority } from '~clients/models';

import { NEED_PRIORITY_LABELS } from '~clients/config/carePlanEnums';

const PRIORITY_OPTIONS = (Object.keys(NEED_PRIORITY_LABELS) as NeedPriority[]).map((value) => ({
  id: value,
  name: NEED_PRIORITY_LABELS[value],
}));

// Search fields for the Assessed Needs tab. A single priority lookup for now; the
// list is filtered client-side (needs lists are small and already fully loaded).
export const needsSearchFields: SearchProps = {
  priority: {
    defaultShow: true,
    type: 'lookup',
    field: 'priority',
    caption: 'Priority',
    placeholder: 'All priorities',
    options: PRIORITY_OPTIONS,
  },
};

export default needsSearchFields;
